import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { notifyBroadcastApi } from '@/api/notify'
import type { notifyBroadcastItem } from '@/api/notify'

export const useBroadcastStore = defineStore('broadcast', () => {
  const list = ref<notifyBroadcastItem[]>([])
  const currentIndex = ref(0)
  const visible = ref(false)
  const loading = ref(false)

  const current = computed(() => list.value[currentIndex.value] ?? null)
  const hasMultiple = computed(() => list.value.length > 1)
  const isFirst = computed(() => currentIndex.value === 0)
  const isLast = computed(() => currentIndex.value >= list.value.length - 1)
  const pageLabel = computed(() => `${currentIndex.value + 1}/${list.value.length}`)

  async function fetchAndShow() {
    if (loading.value) return

    loading.value = true
    try {
      const { data } = await notifyBroadcastApi()
      const items = data?.list ?? []
      if (!items.length) return

      list.value = items
      currentIndex.value = 0
      visible.value = true
    } catch (error) {
      console.error('[Broadcast] 获取公告失败:', error)
    } finally {
      loading.value = false
    }
  }

  function goPrev() {
    if (currentIndex.value > 0) {
      currentIndex.value -= 1
    }
  }

  function goNext() {
    if (!isLast.value) {
      currentIndex.value += 1
    }
  }

  function handleConfirm() {
    if (hasMultiple.value && !isLast.value) {
      goNext()
      return
    }
    close()
  }

  function close() {
    visible.value = false
    list.value = []
    currentIndex.value = 0
  }

  return {
    list,
    currentIndex,
    visible,
    loading,
    current,
    hasMultiple,
    isFirst,
    isLast,
    pageLabel,
    fetchAndShow,
    goPrev,
    goNext,
    handleConfirm,
    close,
  }
})
